// Import Chakra UI components
import { Box, Button, Flex, Heading, Icon, Image, ListItem, Stack, Text, UnorderedList, VStack } from "@chakra-ui/react";
import { FaQuoteLeft } from "react-icons/fa";
import {  useNavigate } from 'react-router-dom';

// Import images
import heroImg from "../../../../assets/new-images/images/rant-vant-out-hero-img.png";
import sec2Img from "../../../../assets/new-images/images/rantvant-sec2-img.png";
import mental3 from "../../../../assets/new-images/images/rent-outt.png";
// Import custom components
import HolisticWelness from "../dating-relationship/component/mental-wellness";
import { Coaches } from "../../../../component/cards/coaches";
import Faqs from "../../../../component/faqs/index";
import WhatYouGain from "../dating-relationship/component/what-gain";
import FaqRant from "../../../../component/faq-rant-vant-out";
import { Link } from "react-router-dom";
import { useAuthenticationSlice } from "../../../../redux/features";

const struggleListing = [
  "Overwhelming stress",
  "Emotional turmoil",
  "Bottled-up feelings",
  "Communication barriers",
  "Mental exhaustion",
  "Loneliness and Isolation",
  "Decision paralysis",
  "Lack of support",
  "Coping with trauma",
  "Seeking Validations",
];

const dataa = [
  "Release pent-up emotions and frustrations, leading to a sense of relief.",
  "Feel heard, understood, and supported in a safe and non-judgmental environment.",
  "Gain clarity and perspective on your challenges by expressing them openly and honestly.",
  "Reduce stress and tension, promoting overall emotional well-being and mental health.",
];

const data = {
  row1: [
    {
      title: "Active Listening",
      content:
        "Our listeners are trained to provide empathetic and non-judgmental support, allowing you to express yourself freely.",
    },
    {
      title: "Emotional Validation",
      content:
        "We understand that your feelings are valid, and we're here to acknowledge and validate them without criticism.",
    },
    {
      title: "Confidentiality",
      content:
        "Your privacy is our priority. Rest assured that anything you share during your rant session will be kept confidential.",
    },
  ],
};
const RantVantOut = () => {
  const navigate = useNavigate();
        const { authentication } = useAuthenticationSlice();
  return (
    <Box className="main-container">
      <Box
        sx={{
          filter: "brightness(1.2)", // Adjust the brightness here
        }}
        className="section-container"
        bgImage={heroImg}
        bgPosition={"center"}
        bgRepeat={"no-repeat"}
        bgSize={"cover"}
      >
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
          h={"auto"}
          py={{ base: 16, md: 16, lg: 32 }}
        >
          <Box textAlign={"center"}>
            <Text className="heading" color={"var(--peach)"}>
              RANT (VENT IT OUT)
            </Text>
            <Text
              color={"white"}
              fontSize={{ base: "xl", md: "2xl", lg: "4xl" }}
              fontWeight={600}
              mt={2}
            >
              Release, Renew, Reclaim: Find Relief with <br /> Our Rant Support
            </Text>
          </Box>
        </Flex>
      </Box>

      <Box mt={16} py={14} className="section-container" bg="pink.50">
      <VStack spacing={6} textAlign="center">
        <Heading
          as="h2"
          fontSize={{ base: "2xl", md: "3xl" }}
          color={"var(--peach)"}
          fontWeight="bold"
        >
          Let Go of Stress and Tension in a Safe Environment, without the fear of being judged.
        </Heading>

        <Text fontSize="lg" color="gray.700">
          Our <strong>Rant (Vent it Out) Services</strong>, where your feelings find a safe harbour amidst life's storms. We understand that sometimes, the weight of emotions can be too heavy to carry alone.
        </Text>

        <Text fontSize="lg" color="gray.700">
          That's why we're here, offering you a compassionate space to unload, express, and release whatever's weighing on your heart and mind.
        </Text>

        <Text fontSize="lg" color="gray.700">
          We believe that sharing your burdens is the first step towards healing, and we're here to listen, without judgement or interruption. So take a deep breath, let it all out, and know that you're not alone on this journey.
        </Text>
      </VStack>
    </Box>

      {/* second section */}

      <Box>
        <Box className="section-container" pt={{ base: 10, md: 16 }} pb={12}>
          <Flex
            gap={{ base: 6, md: 10 }}
            justifyContent={"space-between"}
            alignItems={"center"}
            flexDirection={{ base: "column", md: "row" }}
          >
            <Box>
              <Text className="heading" color={"var(--peach)"}>
                We understand your pains:
              </Text>
              <Text
                className="paragraph"
                fontSize={'20px'}
                mt={4}
                w={{ base: "100%", md: "90%" }}
              >
                We understand the weight of stress, loneliness, and bottled-up
                emotions. You're not alone—let us support and guide you through
                it.
              </Text>
              <UnorderedList mt={6} spacing={4}>
                {struggleListing.map((list, index) => (
                  <ListItem fontSize={'20px'} key={index}>{list}</ListItem>
                ))}
              </UnorderedList>
            </Box>
            <Box>
              <Image
                src={sec2Img}
                alt="sec2Img"
                w={"100%"}
                h={"100%"}
                maxH={"800px"}
              />
            </Box>
          </Flex>
        </Box>
        <Box
      
          py={8}
        >
          <Text my={5} fontSize={'22px'} className="section-container paragraph" textAlign={"left"}>
          Bottling up emotions and frustrations can lead to increased stress and tension. You feel overwhelmed by life's challenges without an outlet for release.
          </Text>
          <Text fontSize={'22px'} className="section-container paragraph" textAlign={"left"}>
          If you are struggling to find someone who will listen without judgement or interruption
          </Text>
        </Box>
        <Flex justifyContent={"center"} alignItems={"center"}>
         
         <Button
            my={{ base: 2, md: 2, lg: 2 }}
            bg={"var(--peach)"}
            color={"white"}
            px={8}
            py={{ base: 6, md: 6, lg: 7 }}
            rounded={"full"}
            fontWeight={600}
            fontSize={{ base: "16px", md: "16px", lg: "18px" }}
            onClick={() => {
              if(!authentication){
                navigate('/sign-in')

              }else{
                navigate('/mentor/list')

              }
            }}
            colorScheme=""
          >
            Feel Free to Connect with Us
          </Button>
        </Flex>
      </Box>

      <Box mb={10}
          
          py={2}
        >
          <Text my={6} fontSize={'22px'} className="section-container paragraph" textAlign={"left"}>
          Whether you're dealing with work-related stress, relationship issues, or simply need to vent about life's frustrations, our trained listeners are here to offer support and understanding. You can pour out your heart without fear of judgement or interruption, allowing you to release negative emotions and find relief
          </Text>
        </Box>

      <Box>
        <HolisticWelness
          Mainheading="Rant (Vent It Out): Your Safe Space to Release & Heal"
          Mainpara="At AlterBuddy, we offer more than just guidance—we create a safe, nurturing space where you can heal, grow, and rediscover your inner strength. Through a blend of evidence-based techniques and spiritual healing, we help you release past wounds, restore balance, and embrace a renewed sense of peace and clarity."
          data={data}
        />
      </Box>

      <Box>
        <WhatYouGain
          gainList={dataa}
          gainImg={mental3}
          heading="WHAT DO YOU GET?"
        />
      </Box>

      {/* <Box>
        <Coaches categoryId={'67f3a4b771662664c3028427'}/>
      </Box> */}

<Flex justifyContent={"center"} alignItems={"center"}>
         
         <Button
            my={{ base: 6, md: 4, lg: 4 }}
            bg={"var(--peach)"}
            color={"white"}
            px={8}
            py={{ base: 6, md: 6, lg: 7 }}
            rounded={"full"}
            fontWeight={600}
            fontSize={{ base: "16px", md: "16px", lg: "18px" }}
            onClick={() => {
              if(!authentication){
                navigate('/sign-in')

              }else{
                navigate('/mentor/list')

              }
            }}
            colorScheme=""
          >
            Feel Free to Connect with Us
          </Button>
        </Flex>

      <Box
                                as="blockquote"
                                bg="gray.50"
                                borderLeft="6px solid"
                                borderColor="#D86570"
                                boxShadow="md"
                                p={6}
                                mt={4}
                                rounded="md"
                                position="relative"
                                mx={{ base: "1rem", md: "1.2rem", lg:"4.5rem" }}
                              >
                                <Stack direction="row" align="start" spacing={3}>
                                  <Icon as={FaQuoteLeft} boxSize={6} color="#D86570" mt={1} />
                                  <Text fontSize={'22px'} color="gray.700" fontStyle="italic">
                                    “Sometimes, the most powerful thing you can do is simply let it out. By giving voice to your struggles and frustrations, you create space for healing and transformation to occur.”
                                  </Text>
                                </Stack>
                                <Text
                                  mt={4}
                                  textAlign="right"
                                  fontWeight="semibold"
                                  fontSize="lg"
                                  color="gray.600"
                                  as="cite"
                                  display="block"
                                >
                                  —  Unknown
                                </Text>
                              </Box>

      <Box pt={8} pb={14}>
        <Box className="section-container">
          <Flex marginX="auto" flexDirection="column" width="100%">
            <Flex justifyContent="center" pb={4}>
              <Heading mt={6} size="lg">
                Frequently Asked Questions
              </Heading>
            </Flex>
            <FaqRant />
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};
export default RantVantOut;
